module.exports = __webpack_public_path__ + "static/img/produce19.6956afd.png";


//////////////////
// WEBPACK FOOTER
// ./src/module/technology/images/produce19.png
// module id = 149
// module chunks = 4